import { render, staticRenderFns } from "./Periodical.vue?vue&type=template&id=41046a78&scoped=true&"
import script from "./Periodical.vue?vue&type=script&lang=js&"
export * from "./Periodical.vue?vue&type=script&lang=js&"
import style0 from "./Periodical.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Periodical.vue?vue&type=style&index=1&id=41046a78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41046a78",
  null
  
)

export default component.exports